import { company } from '@cascade/core/constants';
import { useI18n } from '@cascade/react/i18n';
import { Image, Text } from '@cascade/ui-library';
import clsx from 'clsx';
import classes from './PoweredBy.module.scss';
import type { TPoweredByProps } from './PoweredBy.types.ts';
import logoSmallUrl from './logo-small.svg';
import logoSymbolUrl from './logo-symbol.svg';

export const PoweredBy = ({ isRail }: TPoweredByProps) => {
  const { translate } = useI18n();

  return (
    <div className={clsx(classes['powered-by'], { [classes.rail]: isRail })}>
      {isRail ? null : (
        <Text
          type='caption'
          color='text-30'
          content={translate('brand.poweredBy')}
        />
      )}
      <Image
        src={isRail ? logoSymbolUrl : logoSmallUrl}
        title={company.name}
        className={classes.logo}
      />
    </div>
  );
};
